// Enviament Estàndard gratis a partir del llindar que calcula el servidor (/shop/free-shipping, 2026-10-12):
// just per sobre del tiquet habitual, perquè el comprador típic hi afegeixi un quadern més.
// El servidor també l'aplica a /create-payment-intent; aquí només es mostra.
import axios from 'axios'
import Vue from 'vue'

let promise = null
export function loadFreeShipping() {
  if (!promise) {
    promise = axios.get('/shop/free-shipping').then(r => r.data)
    promise.catch(() => { promise = null })
  }
  return promise
}

// ----------------------------------
// Enviament gratis personal del 2n correu de cistella abandonada (2026-10-15)
// ----------------------------------
// L'enllaç porta ?enviament=<codi>. El codi val una sola vegada, només amb el correu on es va enviar i fins que caduca:
// el servidor ho comprova a /shop/free-shipping-offer/check i a /create-payment-intent.
const OFFER_KEY = 'free_shipping_offer'

export const offerState = Vue.observable({offer: readOffer()})

function readOffer() {
  try {
    const offer = JSON.parse(localStorage.getItem(OFFER_KEY) || 'null')
    if (offer && offer.token && new Date(offer.expires_at) > new Date()) return offer
    localStorage.removeItem(OFFER_KEY)
  } catch (e) {
    // sense localStorage
  }
  return null
}

/** El codi de l'enviament gratis, si n'hi ha un de desat i encara no ha caducat */
export function getOffer() {
  if (offerState.offer && new Date(offerState.offer.expires_at) <= new Date()) clearOffer()
  return offerState.offer
}

export function clearOffer() {
  offerState.offer = null
  try { localStorage.removeItem(OFFER_KEY) } catch (e) { /* res */ }
}

/** Valida el codi de l'enllaç i el desa. Retorna l'oferta o null si ja no val (gastat, caducat o desconegut). */
export async function loadOffer(token) {
  try {
    const {data} = await axios.get(`/shop/free-shipping-offer/${encodeURIComponent(token)}`)
    if (!data || !data.valid) {
      clearOffer()
      return {valid: false, reason: data && data.reason}
    }
    const offer = {token, expires_at: data.expires_at, email_hint: data.email_hint}
    offerState.offer = offer
    try { localStorage.setItem(OFFER_KEY, JSON.stringify(offer)) } catch (e) { /* res */ }
    return {valid: true, offer}
  } catch (e) {
    return {valid: false}
  }
}

/** Abans de crear el pagament: el codi només val amb el correu on es va enviar */
export async function checkOffer(email) {
  const offer = getOffer()
  if (!offer) return {valid: false, reason: 'none'}
  try {
    const {data} = await axios.post('/shop/free-shipping-offer/check', {token: offer.token, email})
    return data || {valid: false}
  } catch (e) {
    return {valid: false, reason: 'error'}
  }
}

/** "dissabte 17 d’octubre a les 15:07" */
export function offerDeadline(offer) {
  const d = new Date(offer.expires_at)
  return d.toLocaleDateString('ca-ES', {weekday: 'long', day: 'numeric', month: 'long'}) + ' a les ' +
    d.toLocaleTimeString('ca-ES', {hour: '2-digit', minute: '2-digit'})
}

export function productsTotal(items) {
  return Math.round((items || []).reduce((s, i) => s + i.price * i.quantity, 0) * 100) / 100
}

/** Còpia de les tarifes amb l'Estàndard a 0 € si els productes arriben al llindar o hi ha l'enviament gratis personal */
export async function applyFreeShipping(shippings, items) {
  let rule = null
  try {
    rule = await loadFreeShipping()
  } catch (e) {
    rule = null
  }
  const byThreshold = rule && rule.threshold && productsTotal(items) >= rule.threshold
  if (!byThreshold && !getOffer()) return shippings
  return (shippings || []).map(s => s.title === 'Estàndard' ? {...s, price: 0} : s)
}
